
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.77 2.667v2c0 .4-.256.666-.639.666s-.638-.266-.638-.666V3.333H8.666v9.334h1.276c.383 0 .638.266.638.666s-.255.667-.638.667H6.114c-.382 0-.637-.267-.637-.667s.255-.666.637-.666H7.39V3.333H3.563v1.334c0 .4-.255.666-.638.666s-.638-.266-.638-.666v-2c0-.4.255-.667.638-.667h10.206c.383 0 .638.267.638.667z","fill":"#000"}})])
          )
        }
      }
    